import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import { $Q } from '../utils/querySelector';
import 'swiper/css';

class Reviews {
  constructor() {
    this.reviews = $Q('.reviews__slider');

    this.reviews && this._init();
  }
  /**
   * Initialize reviews feature
   * @auhtor Daniel Santos <daniel.santos@gradiweb.com>
   */

  _init() {
    this._initReviewsSlider();
  }

  /**
   * Initialize reviews slider with swiper slider
   * @auhtor Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initReviewsSlider() {
    this.slide = new Swiper(this.reviews, {
      modules: [Navigation, Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 8,
      loop: true,
      pagination: {
        el: '.swiper-reviews-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: `.swiper-button-next.swiper-reviews-button`,
        prevEl: `.swiper-button-prev.swiper-reviews-button`,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        720: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  }
}

export { Reviews };
